export default __webpack_public_path__ + "1a45e36caca6fc37342a9abc20069455.woff";